import React, { useEffect, useState } from "react";
import { IoIosLock } from "react-icons/io";
import styled from "styled-components";
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid var(--tertiary-font-color);
  padding: 4px;
  border-radius: 5px;
  gap: 8px;
  //  width: 100%; /* Ensures wrapper takes full width */
  input,
  textarea,
  select {
    border: none;
    outline: none;
    font-size: 1rem;
    background: transparent;
    color: var(--secondary-font-color);
    width: 100%; /* Makes sure both input & textarea take full width */
    flex: 1; /* Helps maintain equal width inside flex container */
  }

  svg {
    color: var(--secondary-font-color);
    font-size: 1.2rem;
  }
`;

export interface InputFieldProps {
  values: { value: string; label: string }[];
  onChange: ({ value, label }: { value: string; label: string }) => void;
  name: string;
  icon?: React.ReactNode;
  label?: string;
  readonly?: boolean;
  currentValue?: { value: string; label: string };
}

const SimpleDropdown: React.FC<InputFieldProps> = ({
  values,
  onChange,
  name,
  icon,
  label,
  readonly,
  currentValue,
}) => {
  const [selectedValue, setSelectedValue] = useState(
    currentValue?.value || values?.[0]?.value || ""
  );

  const handleSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    const selectedLabel =
      values.find((item) => item.value === selectedValue)?.label || "";

    setSelectedValue(selectedValue);
    onChange({ value: selectedValue, label: selectedLabel });
  };

  useEffect(() => {
    if (currentValue && currentValue.value) {
      setSelectedValue(currentValue.value);
      onChange({ value: currentValue.value, label: currentValue.label });
    } else if (values && values.length > 0) {
      setSelectedValue(values[0].value);
      onChange({ value: values[0].value, label: values[0].label });
    }
  }, [currentValue]);

  return (
    <Wrapper>
      {label && <div style={{ paddingBottom: "6px" }}>{label}</div>}
      <InputWrapper
        style={{
          backgroundColor: readonly ? "#a8a7a745" : "transparent",
        }}
      >
        {readonly ? <IoIosLock /> : icon}
        <select
          name={name}
          value={selectedValue}
          onChange={values && values.length > 0 ? handleSelect : () => {}}
          disabled={readonly}
        >
          {values &&
            values.length > 0 &&
            values.map(({ value, label }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
        </select>
      </InputWrapper>
    </Wrapper>
  );
};

export default SimpleDropdown;
